// extracted by mini-css-extract-plugin
export var cardIcon = "_85-5";
export var cardIconUnframed = "_85-9";
export var checkboxCard = "_85-0";
export var checkboxCardSelected = "_85-4";
export var disabled = "_85-2";
export var interactive = "_85-1";
export var outerBorder = "_85-3";
export var spacerMedium = "_85-8";
export var spacerSmall = "_85-7";
export var spacerXsmall = "_85-6";